/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { SavedTableView } from 'types/entities/SavedTableView'
import { TableViewId } from 'types/enums/specific/TableViewId'

/** Suggested outreach tag for leads waiting on a response. */
export const LEAD_FOLLOW_UP_TAG = 'not responded'

/** Built-in Leads saved view that filters by {@link LEAD_FOLLOW_UP_TAG}. */
export const LEAD_FOLLOW_UP_VIEW_NAME = 'Follow-up open'

/** Negative id so system presets never collide with BE-saved views. */
export const LEAD_FOLLOW_UP_VIEW_ID = -1001

export const LEAD_PRESET_TAGS = [LEAD_FOLLOW_UP_TAG] as const

export const isSystemSavedTableView = (view: Pick<SavedTableView, 'id'>): boolean =>
    Number(view.id) < 0

export const mergePresetTagsIntoCatalog = (tags: string[]): string[] => {
    const merged: string[] = []
    const seen = new Set<string>()

    for (const tag of [...LEAD_PRESET_TAGS, ...tags]) {
        const trimmed = String(tag ?? '').trim()
        if (!trimmed) continue
        const key = trimmed.toLowerCase()
        if (seen.has(key)) continue
        seen.add(key)
        merged.push(trimmed)
    }

    return merged
}

export const getLeadSystemPresetViews = (sellerId: number): SavedTableView[] => [
    {
        id: LEAD_FOLLOW_UP_VIEW_ID,
        name: LEAD_FOLLOW_UP_VIEW_NAME,
        table_id: TableViewId.Leads,
        seller_id: sellerId,
        state: {
            columnFilters: [
                {
                    id: 'tags',
                    value: {
                        include: [LEAD_FOLLOW_UP_TAG],
                        exclude: [],
                    },
                },
            ],
            globalFilter: '',
            sorting: [],
            columnVisibility: {},
            pageSize: 25,
        },
    },
]
